module.exports = "/images/Visa.svg?9d63747c016dcd9a9c4e0b24f2e219de";